import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';

import { Facet } from 'ish-core/models/facet/facet.model';
import { Filter } from 'ish-core/models/filter/filter.model';
import { URLFormParams } from 'ish-core/utils/url-form-params';

/**
 * The Filter Dropdown Component displays a filter group. The items of the filter group are presented as a dropdown menu.
 *
 * @example
 * <ish-filter-dropdown
 *   [filterElement]="element"
 *   [placeholderType]="'selectedFacets'"
 *   (applyFilter)="applyFilter($event)">
 * </ish-filter-dropdown>
 */
@Component({
  selector: 'ish-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./filter-dropdown.component.scss'],
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgClass, FaIconComponent],
})
export class FilterDropdownComponent implements OnInit {
  readonly filterElement = input.required<Filter>();
  readonly placeholderType = input<'groupName' | 'selectedFacets'>('groupName');
  readonly applyFilter = output<{
    searchParameter: URLFormParams;
  }>();

  placeholder = '';

  apply(facet: Facet) {
    this.applyFilter.emit({ searchParameter: facet.searchParameter });
  }

  trackByFn(_: number, item: Facet) {
    return item.name;
  }

  ngOnInit() {
    this.initPlaceHolder();
  }

  private initPlaceHolder() {
    this.placeholder = this.filterElement().name;

    const selectedFacets = this.filterElement().facets.filter(x => x.selected);

    if (this.placeholderType() === 'selectedFacets') {
      const placeholder = selectedFacets.map(x => x.displayName).join(', ');

      if (placeholder) {
        this.placeholder = placeholder;
      }
    }
  }
}
